import React from 'react';
import styled from 'styled-components';

const Hashtag = styled.span`
  color: #ff8e53;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const renderWithHashtags = (text: string) => {
  return text?.split(' ').map((part, index) => {
    if (part.startsWith('#')) {
      return <Hashtag key={index}>{part}</Hashtag>;
    }
    return part + ' ';
  });
}; 